import { buildGlobalAction, buildInlineComputedView } from "./../builder.js";
class KlaviyoNamespace {
  constructor(clientOrParent) {
    this.clientOrParent = clientOrParent;
    /** Executes the disconnect global action. */
    this.disconnect = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "disconnect",
      operationName: "disconnect",
      operationReturnType: "KlaviyoDisconnect",
      namespace: "klaviyo",
      variables: { customerId: { required: false, type: "String" } }
    });
    /** Executes the getSegments global action. */
    this.getSegments = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "getSegments",
      operationName: "getSegments",
      operationReturnType: "KlaviyoGetSegments",
      namespace: "klaviyo",
      variables: {
        klaviyoToken: { required: false, type: "String" },
        klaviyoAccessToken: { required: false, type: "String" }
      }
    });
    /** Executes the refreshAccessToken global action. */
    this.refreshAccessToken = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "refreshAccessToken",
      operationName: "refreshAccessToken",
      operationReturnType: "KlaviyoRefreshAccessToken",
      namespace: "klaviyo",
      variables: { customerId: { required: false, type: "String" } }
    });
    /** Executes the refreshAllCustomerTokens global action. */
    this.refreshAllCustomerTokens = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "refreshAllCustomerTokens",
      operationName: "refreshAllCustomerTokens",
      operationReturnType: "KlaviyoRefreshAllCustomerTokens",
      namespace: "klaviyo",
      variables: {}
    });
    /** Executes the sendMessage global action. */
    this.sendMessage = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "sendMessage",
      operationName: "sendMessage",
      operationReturnType: "KlaviyoSendMessage",
      namespace: "klaviyo",
      variables: {
        apikey: { required: false, type: "String" },
        phone: { required: false, type: "String" },
        campaign: { required: false, type: "String" }
      }
    });
    /** Executes an inline computed view. */
    this.view = buildInlineComputedView(this, {
      type: "computedView",
      operationName: "gellyView",
      functionName: "view",
      gqlFieldName: "gellyView",
      namespace: "klaviyo",
      variables: {
        query: { type: "String", required: true },
        args: { type: "JSONObject" }
      }
    });
    this.connection = this.clientOrParent.connection;
  }
}
export {
  KlaviyoNamespace
};
//# sourceMappingURL=klaviyo.js.map
